import React from 'react';
import "./Works.css";
import img1 from "../../assets/finway.png";
import img2 from "../../assets/vaccine.png";
import img3 from "../../assets/color.png";
import img4 from "../../assets/plant.png";
import img5 from "../../assets/language.png";
const Works = () => {
  return (
    <div className='works-container'>
        <h1>Glimpse of my work</h1>
        <div className='works-list-container'>
            <div className='works-item'>
                <img src={img1} alt="works-img-1"/>
            </div>
            <div className='works-item'>
                <img src={img2} alt="works-img-2"/>
            </div>
            <div className='works-item'>
                <img src={img4} alt="works-img-3"/>
            </div>
            <div className='works-item'>
                <img src={img5} alt="works-img-5"/>
            </div>
            <div className='works-item'>
                <img src={img3} alt="works-img-3"/>
            </div>
        </div>
    </div>
  );
};

export default Works;